import { useEffect, useState } from "react";
import { G } from "../constants/theme";
import Label from "../components/ui/Label";
import BigTitle from "../components/ui/BigTitle";
import BodyText from "../components/ui/BodyText";
import { BtnG, BtnO } from "../components/ui/Buttons";
import { Wrap, Sec } from "../components/ui/Layout";
import PageHero from "../components/ui/PageHero";
import SR from "../components/ui/SR";
import SI from "../components/ui/SI";

const SPECS = [
  { p: "Moisture",             v: "0.09 %" },
  { p: "Ash Content",          v: "12.4 %" },
  { p: "Volatile Matter",      v: "0.67 %" },
  { p: "Fixed Carbon",         v: "64.54 %" },
  { p: "Gross Calorific Value", v: "21,671 kJ/kg" },
  { p: "Product Form",         v: "Powder" },
  { p: "Source",               v: "End-of-life tire pyrolysis" },
];

const SUPPLY = [
  { k: "Available Quantity",    v: "~1,000 metric tons" },
  { k: "Product Form",          v: "Powder" },
  { k: "Packaging",             v: "Confirmed with buyer" },
  { k: "Samples",               v: "Available on request" },
  { k: "Technical Documents",   v: "Available on request" },
  { k: "Commercial Contact",    v: "Canada" },
];

export default function Product({ onNavigate }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <>
      <PageHero
        label="Product"
        title={
          <>
            RECOVERED CARBON
            <br />
            BLACK (rCB) – POWDER
          </>
        }
        sub="Produced through tire pyrolysis using end-of-life tires. Available in powder form for industrial evaluation and bulk supply."
      />

      {/* Specifications */}
      <Sec bg={G.black}>
        <Wrap>
          <Label>Laboratory Analysis</Label>
          <BigTitle>TECHNICAL SPECIFICATIONS</BigTitle>
          <div style={{ border: `1px solid ${G.border}`, overflow: "hidden", marginBottom: 16 }}>
            <table>
              <thead>
                <tr>
                  <th
                    style={{
                      fontFamily: "monospace",
                      fontSize: 10,
                      letterSpacing: 2,
                      color: G.green,
                      textAlign: "left",
                      padding: "14px 22px",
                      borderBottom: `1px solid ${G.border}`,
                      background: G.surface,
                      textTransform: "uppercase",
                      width: "55%",
                    }}
                  >
                    Property
                  </th>
                  <th
                    style={{
                      fontFamily: "monospace",
                      fontSize: 10,
                      letterSpacing: 2,
                      color: G.green,
                      textAlign: "left",
                      padding: "14px 22px",
                      borderBottom: `1px solid ${G.border}`,
                      background: G.surface,
                      textTransform: "uppercase",
                    }}
                  >
                    Result
                  </th>
                </tr>
              </thead>
              <tbody>
                {SPECS.map((s) => (
                  <SR key={s.p} p={s.p} v={s.v} />
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{
              padding: "14px 18px",
              borderLeft: `2px solid ${G.greenDim}`,
              background: G.surface,
              fontSize: 12,
              color: G.muted,
            }}
          >
            ⚠ Full lab reports available to qualified buyers upon request.
          </div>
        </Wrap>
      </Sec>

      {/* Supply info */}
      <Sec bg={G.deep}>
        <Wrap>
          <Label>Availability</Label>
          <BigTitle>SUPPLY INFORMATION</BigTitle>
          <BodyText>The material is available for bulk supply and sample evaluation.</BodyText>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(3,1fr)",
              gap: 1,
              background: G.border,
              border: `1px solid ${G.border}`,
              marginBottom: 36,
            }}
          >
            {SUPPLY.map((s) => (
              <SI key={s.k} k={s.k} v={s.v} />
            ))}
          </div>
          <div style={{ display: "flex", gap: 14 }}>
            <BtnG onClick={() => onNavigate("technical")}>Request Technical Data</BtnG>
            <BtnO onClick={() => onNavigate("contact")}>Contact Our Team</BtnO>
          </div>
        </Wrap>
      </Sec>
    </>
  );
}
